const prefix = '/onlinecs/goodsknowledge'

/**
 * 商品列表
 * @type {string}
 */
export const queryGoodsKnowledgePage = `${prefix}/queryGoodsKnowledgePage`

/**
 * 下载更新商品or新增商品自定义属性模版
 * @type {string}
 */
export const downloadGoodsKnowledgeModel = `${prefix}/downloadGoodsKnowledgeModel`

/**
 * 批量导入更新商品or新增商品自定义属性
 * @type {string}
 */
export const batchImportGoodsKnowledge = `${prefix}/batchImportGoodsKnowledge`

/**
 * 更新商品知识库
 * @type {string}
 */
export const updateGoodsKnowledge = `${prefix}/updateGoodsKnowledge`
